<div class="permission-group-grid">
  @for (group of groups(); track group.resource) {
    <section class="perm-group">
      <header class="perm-group__header">
        <div class="perm-group__title">
          <span class="perm-group__icon"><i [class]="group.icon"></i></span>
          <h3>{{ group.label }}</h3>
        </div>
        <div class="perm-group__toggle-all">
          <span>Select all</span>
          <p-toggleswitch
            [ngModel]="groupAllChecked(group)"
            [disabled]="disabled()"
            (onChange)="onToggleGroup(group, $event.checked)"
          />
        </div>
      </header>

      <div class="perm-group__grid">
        @for (perm of group.permissions; track perm.id) {
          <div class="perm-item" [class.perm-item--inherited]="isInherited(perm.id)">
            <div class="perm-item__info">
              <div class="perm-item__name">
                {{ perm.name }}
                @if (isInherited(perm.id)) {
                  <span class="perm-item__badge"
                    ><i class="pi pi-id-card"></i>{{ roleBadgeLabel() }}</span
                  >
                }
              </div>
              @if (perm.description) {
                <div class="perm-item__desc">{{ perm.description }}</div>
              }
            </div>
            <p-toggleswitch
              [ngModel]="isChecked(perm.id)"
              [disabled]="disabled() || isInherited(perm.id)"
              (onChange)="onToggle(perm.id, $event.checked)"
            />
          </div>
        }
      </div>
    </section>
  }
</div>
